/* eslint-disable max-len */
/**
 * Awvent - Products API
 * Awvent Products Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { environment }                                        from '../../../../../environments/environment';

import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';
import { SalesPitchDtoWebApiResponse } from '../model/salesPitchDtoWebApiResponse';
import { SalesPitchDtoListWebApiPagedResponse } from '../model/salesPitchDtoListWebApiPagedResponse';
import { SalesPitchCreateCommand } from '../model/salesPitchCreateCommand';
import { SalesPitchUpdateCommand } from '../model/salesPitchUpdateCommand';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH } from '../../../../variables';

@Injectable()
export class SalesPitchService {

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    protected basePath = environment.api.products;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchActivateIdPut(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<SalesPitchDtoWebApiResponse>;
    public salesPitchActivateIdPut(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SalesPitchDtoWebApiResponse>>;
    public salesPitchActivateIdPut(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SalesPitchDtoWebApiResponse>>;
    public salesPitchActivateIdPut(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling salesPitchActivateIdPut.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchActivateIdPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SalesPitchDtoWebApiResponse>('put',`${this.basePath}/SalesPitch/Activate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchDeactivateIdPut(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<SalesPitchDtoWebApiResponse>;
    public salesPitchDeactivateIdPut(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SalesPitchDtoWebApiResponse>>;
    public salesPitchDeactivateIdPut(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SalesPitchDtoWebApiResponse>>;
    public salesPitchDeactivateIdPut(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling salesPitchDeactivateIdPut.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchDeactivateIdPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SalesPitchDtoWebApiResponse>('put',`${this.basePath}/SalesPitch/Deactivate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param isActive
     * @param businessAccountId
     * @param productId
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchGet(xTenantId: string, isActive?: boolean, businessAccountId?: string, productId?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<SalesPitchDtoListWebApiPagedResponse>;
    public salesPitchGet(xTenantId: string, isActive?: boolean, businessAccountId?: string, productId?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SalesPitchDtoListWebApiPagedResponse>>;
    public salesPitchGet(xTenantId: string, isActive?: boolean, businessAccountId?: string, productId?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SalesPitchDtoListWebApiPagedResponse>>;
    public salesPitchGet(xTenantId: string, isActive?: boolean, businessAccountId?: string, productId?: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchGet.');
        }









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', isActive);
        }
        if (businessAccountId !== undefined && businessAccountId !== null) {
            queryParameters = queryParameters.set('BusinessAccountId', businessAccountId);
        }
        if (productId !== undefined && productId !== null) {
            queryParameters = queryParameters.set('ProductId', productId);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', element);
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', searchText);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SalesPitchDtoListWebApiPagedResponse>('get',`${this.basePath}/SalesPitch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchIdDelete(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public salesPitchIdDelete(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public salesPitchIdDelete(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public salesPitchIdDelete(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling salesPitchIdDelete.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/SalesPitch/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<SalesPitchDtoWebApiResponse>;
    public salesPitchIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SalesPitchDtoWebApiResponse>>;
    public salesPitchIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SalesPitchDtoWebApiResponse>>;
    public salesPitchIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling salesPitchIdGet.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchIdGet.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SalesPitchDtoWebApiResponse>('get',`${this.basePath}/SalesPitch/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchPost(xTenantId: string, body?: SalesPitchCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<SalesPitchDtoWebApiResponse>;
    public salesPitchPost(xTenantId: string, body?: SalesPitchCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SalesPitchDtoWebApiResponse>>;
    public salesPitchPost(xTenantId: string, body?: SalesPitchCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SalesPitchDtoWebApiResponse>>;
    public salesPitchPost(xTenantId: string, body?: SalesPitchCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchPost.');
        }



        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SalesPitchDtoWebApiResponse>('post',`${this.basePath}/SalesPitch`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salesPitchPut(xTenantId: string, body?: SalesPitchUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<SalesPitchDtoWebApiResponse>;
    public salesPitchPut(xTenantId: string, body?: SalesPitchUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SalesPitchDtoWebApiResponse>>;
    public salesPitchPut(xTenantId: string, body?: SalesPitchUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SalesPitchDtoWebApiResponse>>;
    public salesPitchPut(xTenantId: string, body?: SalesPitchUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling salesPitchPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SalesPitchDtoWebApiResponse>('put',`${this.basePath}/SalesPitch`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

}
